import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartguy/src/app/(Guest)/catholics-speaks/[videoId]/components/VideoPage.jsx");
